import { pixelsInject } from './module/outstream-pixels';

pixelsInject('').setPubId('puntodebreak');
pixelsInject('').disablePlaylist();
pixelsInject('').setAdTag(
  'https://pubads.g.doubleclick.net/gampad/ads?iu=/22844376944/AA/medios_deportivos/punto_de_break/video/horizontal_instream&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&url=[REFERRER_URL]&correlator=&adrule=0&plcmt=2'
);

pixelsInject('').setBidConfig([{
  bidder: 'rubicon',
  params: {
    accountId: 25822,
    siteId: 607129,
    zoneId: 3918877,
  }
}, {
  bidder: 'pubmatic',
  params: {
    publisherId: '1413439',
    adSlot: '7234851'
  }
}]);

const puntodebreakInject: InjectPixelsLegacy = selector => {
  return {
    setup: async (options, callback) => {
      const result = await pixelsInject(selector).setup({
        ...options,
      });
      callback && callback(result);
    },
  };
};

window.pixelsInject = puntodebreakInject;
